export interface Category {
  id: number;
  nameIt: string;
  nameEn: string;
  link: string;
  icon: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    id: 1,
    nameIt: 'Scarpe',
    nameEn: 'Shoes',
    link: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20pair%20of%20white%20leather%20sneakers%20with%20subtle%20cream%20laces%20on%20a%20light%20warm%20beige%20textured%20surface%2C%20soft%20diffused%20natural%20daylight%20from%20left%2C%20clean%20editorial%20composition%2C%20neutral%20earthy%20tones%2C%20high%20end%20fashion%20catalog%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20no%20people&width=400&height=300&seq=cat-img-shoes-v2&orientation=landscape',
  },
  {
    id: 2,
    nameIt: 'Felpe',
    nameEn: 'Hoodies/Sweaters',
    link: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20soft%20sage%20green%20hoodie%20neatly%20folded%20on%20a%20light%20warm%20gray%20textured%20surface%2C%20soft%20natural%20window%20light%2C%20clean%20editorial%20style%2C%20neutral%20earthy%20tones%2C%20high%20end%20fashion%20catalog%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20no%20people&width=400&height=300&seq=cat-img-hoodies-v2&orientation=landscape',
  },
  {
    id: 3,
    nameIt: 'T-Shirt',
    nameEn: 'T-Shirts',
    link: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20cream%20white%20cotton%20tshirt%20neatly%20folded%20on%20a%20light%20warm%20taupe%20textured%20surface%2C%20soft%20natural%20diffused%20light%2C%20clean%20editorial%20style%2C%20neutral%20earthy%20tones%2C%20high%20end%20fashion%20catalog%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20no%20people&width=400&height=300&seq=cat-img-tshirts-v2&orientation=landscape',
  },
  {
    id: 4,
    nameIt: 'Giacche',
    nameEn: 'Jackets',
    link: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-cloudy-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20dark%20olive%20green%20bomber%20jacket%20laid%20flat%20on%20a%20light%20warm%20beige%20textured%20surface%2C%20soft%20natural%20window%20light%2C%20clean%20editorial%20style%2C%20neutral%20earthy%20tones%2C%20high%20end%20fashion%20catalog%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20no%20people&width=400&height=300&seq=cat-img-jackets-v2&orientation=landscape',
  },
  {
    id: 5,
    nameIt: 'Pantaloni',
    nameEn: 'Pants/Shorts',
    link: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20pair%20of%20tailored%20beige%20trousers%20neatly%20folded%20on%20a%20light%20warm%20cream%20textured%20surface%2C%20soft%20natural%20window%20light%2C%20clean%20editorial%20style%2C%20neutral%20earthy%20tones%2C%20high%20end%20fashion%20catalog%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20no%20people&width=400&height=300&seq=cat-img-pants-v2&orientation=landscape',
  },
  {
    id: 6,
    nameIt: 'Cappelli',
    nameEn: 'Headwear',
    link: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-user-3-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20soft%20cream%20colored%20baseball%20cap%20resting%20on%20a%20light%20warm%20beige%20textured%20surface%2C%20soft%20natural%20window%20light%20from%20above%2C%20clean%20editorial%20style%2C%20neutral%20earthy%20tones%2C%20high%20end%20fashion%20catalog%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20no%20people&width=400&height=300&seq=cat-img-caps-v2&orientation=landscape',
  },
  {
    id: 7,
    nameIt: 'Set Completi',
    nameEn: 'Sets',
    link: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20matching%20hoodie%20and%20sweatpants%20set%20in%20warm%20oatmeal%20color%20neatly%20arranged%20on%20a%20light%20warm%20cream%20textured%20surface%2C%20soft%20natural%20window%20light%2C%20clean%20editorial%20style%2C%20neutral%20earthy%20tones%2C%20high%20end%20fashion%20catalog%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20no%20people&width=400&height=300&seq=cat-img-sets-v2&orientation=landscape',
  },
  {
    id: 8,
    nameIt: 'Intimo',
    nameEn: 'Underwear/Underpants',
    link: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20soft%20cotton%20underwear%20in%20warm%20gray%20tone%20neatly%20placed%20on%20a%20light%20warm%20beige%20textured%20surface%2C%20soft%20natural%20diffused%20light%2C%20clean%20editorial%20style%2C%20neutral%20earthy%20tones%2C%20high%20end%20fashion%20catalog%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20no%20people&width=400&height=300&seq=cat-img-underwear-v2&orientation=landscape',
  },
  {
    id: 9,
    nameIt: 'Jersey',
    nameEn: 'Jersey',
    link: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-football-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20deep%20navy%20blue%20sports%20jersey%20with%20subtle%20stripe%20pattern%20laid%20flat%20on%20a%20light%20warm%20beige%20textured%20surface%2C%20soft%20natural%20window%20light%2C%20clean%20editorial%20style%2C%20neutral%20earthy%20tones%2C%20high%20end%20fashion%20catalog%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20no%20people&width=400&height=300&seq=cat-img-jersey-v2&orientation=landscape',
  },
  {
    id: 10,
    nameIt: 'Accessori',
    nameEn: 'Accessories',
    link: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20pair%20of%20classic%20tortoiseshell%20sunglasses%20and%20a%20minimalist%20leather%20strap%20watch%20on%20a%20light%20warm%20beige%20textured%20surface%2C%20soft%20natural%20window%20light%2C%20clean%20editorial%20style%2C%20neutral%20earthy%20tones%2C%20high%20end%20fashion%20catalog%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20no%20people&width=400&height=300&seq=cat-img-accessories-v2&orientation=landscape',
  },
  {
    id: 11,
    nameIt: 'Borse',
    nameEn: 'Bags',
    link: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-shopping-bag-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20structured%20camel%20brown%20leather%20tote%20bag%20with%20clean%20lines%20on%20a%20light%20warm%20cream%20textured%20surface%2C%20soft%20natural%20window%20light%2C%20clean%20editorial%20style%2C%20neutral%20earthy%20tones%2C%20high%20end%20fashion%20catalog%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20no%20people&width=400&height=300&seq=cat-img-bags-v2&orientation=landscape',
  },
  {
    id: 12,
    nameIt: 'Cinture',
    nameEn: 'Belts',
    link: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20rolled%20dark%20brown%20leather%20belt%20with%20brass%20buckle%20on%20a%20light%20warm%20beige%20textured%20surface%2C%20soft%20natural%20window%20light%2C%20clean%20editorial%20style%2C%20neutral%20earthy%20tones%2C%20high%20end%20fashion%20catalog%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20no%20people&width=400&height=300&seq=cat-img-belts-v2&orientation=landscape',
  },
  {
    id: 13,
    nameIt: 'Profumi',
    nameEn: 'Perfumes',
    link: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20sleek%20amber%20glass%20perfume%20bottle%20with%20minimal%20label%20on%20a%20light%20warm%20beige%20textured%20surface%2C%20soft%20natural%20window%20light%20creating%20subtle%20reflections%2C%20clean%20editorial%20style%2C%20neutral%20earthy%20tones%2C%20high%20end%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20no%20people&width=400&height=300&seq=cat-img-perfumes-v2&orientation=landscape',
  },
  {
    id: 14,
    nameIt: 'Altro',
    nameEn: 'Other Stuff',
    link: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20assorted%20small%20fashion%20accessories%20including%20a%20keychain%2C%20coin%20purse%2C%20and%20sunglasses%20pouch%20on%20a%20light%20warm%20beige%20textured%20surface%2C%20soft%20natural%20window%20light%2C%20clean%20editorial%20style%2C%20neutral%20earthy%20tones%2C%20high%20end%20fashion%20catalog%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20no%20people&width=400&height=300&seq=cat-img-other-v2&orientation=landscape',
  },
];